import { Box, ButtonBase, List, styled } from '@mui/material';

export const EmptyContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  border: `2px solid ${theme.palette.primary.main}`,
  boxShadow: `0px 0px 12px ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.background.secondary,
  color: theme.palette.primary.main,
  display: 'flex',
  height: 220,
  justifyContent: 'center',
  margin: theme.spacing(5),
  width: 360,
}));

export const NotificationsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  margin: theme.spacing(5),
  maxWidth: 360,
}));

export const NewNotificationsBanner = styled(ButtonBase)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(0.75, 2),
  width: '100%',
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  borderRadius: 0,
}));

export const NotificationsList = styled(List)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.secondary,
  border: `2px solid ${theme.palette.primary.main}`,
  boxShadow: `0px 0px 12px ${theme.palette.primary.main}`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  maxHeight: 400,
  overflow: 'auto',
  overscrollBehavior: 'none',
  width: '100%',
}));
